<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="7"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              Promotions and Discounts
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        md="3"
        cols="5"
      >
        <b-button
          v-if="canViewThisAction('create', 'Promotion')"
          variant="success"
          class="mobile_create_button"
          :to="{ name: 'products-promotions-create' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Create new Promotions and Discounts</span>
          <span class="align-middle d-md-none d-block">New</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <feather-icon
              icon="SearchIcon"
              size="18"
              class="mr-50"
            />
            <span class="align-middle">Search</span>

            <b-input-group
              class="input-group-merge mx-50"
            >
              <b-form-input
                v-model="searchQuery"
                placeholder="Name or Coupon Code"
              />
              <b-input-group-append
                v-if="searchQuery"
                is-text
              >
                <feather-icon
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="searchQuery = '';"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <!-- Filter -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-promotion-filter"
                ref="filter_dropdown_promotions"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <promotion-filter
                  :type.sync="typeFilter"
                  :type-options="typeOptions"
                  :status.sync="statusFilter"
                  :status-options="statusOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="typeFilter.length || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="item in typeFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromTypeFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in statusFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refPromotionsTable"
        class="position-relative min-height-table"
        :items="itemListData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(name)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'Promotion')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'products-promotions-show', params: { id: data.item._id } }"
            >
              {{ data.item.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.name }}
            </b-button>
            <div class="text-muted">
              {{ data.item.couponCode || '–' }}
            </div>
          </div>
        </template>

        <template #cell(value)="data">
          <div v-if="data.item.discountType === 'Percentage (%)'">
            <div>{{ data.item.discountValue }}%</div>
            <div
              v-if="data.item.maxDiscountValue"
              class="text-muted"
            >
              Max ${{ numberFormat(data.item.maxDiscountValue) }}
            </div>
          </div>
          <div v-else-if="data.item.discountType === 'Singapore Dollars ($)'">
            ${{ numberFormat(data.item.discountValue) }}
          </div>
          <div v-else>
            –
          </div>
        </template>

        <template #cell(totalQuota)="data">
          {{ data.item.totalQuota != null ? data.item.totalQuota : '–' }}
        </template>

        <template #cell(quotaPerAgent)="data">
          {{ data.item.quotaPerAgent != null ? data.item.quotaPerAgent : '–' }}
        </template>

        <template #cell(validityStartDate)="data">
          {{ data.item.validityStartDate ? dateFormat(data.item.validityStartDate) : '–' }}
        </template>

        <template #cell(validityEndDate)="data">
          {{ data.item.validityEndDate ? dateFormat(data.item.validityEndDate) : '–' }}
        </template>

        <template #cell(status)="data">
          <div>
            <b-badge
              :variant="`light-${resolveStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              <span>{{ data.item.status }}</span>
            </b-badge>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'Promotion') || canViewThisAction('update', 'Promotion') || canViewThisAction('create', 'Promotion') || canViewThisAction('delete', 'Promotion')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'Promotion')"
              :to="{ name: 'products-promotions-show', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Promotion')"
              :to="{ name: 'products-promotions-edit', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('create', 'Promotion')"
              :to="{ name: 'products-promotions-create', query: { from: data.item._id } }"
            >
              <span class="align-middle ml-50">Duplicate</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('delete', 'Promotion')"
              @click="deleteEntity(data.item._id)"
            >
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalPromotions > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalPromotions"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BDropdown, BDropdownItem, BPagination, BFormTag, BBadge,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
// eslint-disable-next-line import/no-cycle
import usePromotionList from './usePromotionList'
import promotionStoreModule from './promotionStoreModule'
import PromotionFilter from './PromotionFilter.vue'

export default {
  components: {
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BBadge,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    PromotionFilter,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      typeOptions: [
        { title: 'Auto apply', code: 'Auto apply' },
        { title: 'Coupon code', code: 'Coupon code' },
      ],
      statusOptions: [
        { title: 'Active', code: 'Active' },
        { title: 'Inactive', code: 'Inactive' },
      ],
    }
  },
  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_promotions.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_promotions.show(true)
    },
    removeFromTypeFilter(type) {
      const index = this.typeFilter.indexOf(type)
      if (index > -1) {
        this.typeFilter.splice(index, 1)
      }
    },
    removeFromStatusFilter(status) {
      const index = this.statusFilter.indexOf(status)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    clearAllFilters() {
      this.typeFilter = []
      this.statusFilter = []
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deletePromotion()
          }
        })
    },
  },
  setup() {
    const PROMOTION_APP_STORE_MODULE_NAME = 'app-promotions'

    // Register module
    if (!store.hasModule(PROMOTION_APP_STORE_MODULE_NAME)) store.registerModule(PROMOTION_APP_STORE_MODULE_NAME, promotionStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PROMOTION_APP_STORE_MODULE_NAME)) store.unregisterModule(PROMOTION_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchPromotions,
      tableColumns,
      perPage,
      currentPage,
      totalPromotions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPromotionsTable,
      refetchData,

      toDeletedID,
      deletePromotion,
      currentDataLength,
      itemListData,

      resolveStatusVariant,

      typeFilter,
      statusFilter,
    } = usePromotionList()

    const showSearchBar = ref(false)
    if (searchQuery.value) {
      showSearchBar.value = true
    }

    return {
      fetchPromotions,
      tableColumns,
      perPage,
      currentPage,
      totalPromotions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPromotionsTable,
      refetchData,
      showSearchBar,
      toDeletedID,
      deletePromotion,
      currentDataLength,
      itemListData,

      canViewThisAction,

      resolveStatusVariant,

      typeFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
